import { InitialLocationCallback } from '../../map-container/map-initial-location.provider';
import { MapItemDetailsProvider } from '../../map-item-details-provider/map-item-details.provider';
import { MapComponent } from '../../map.component';
import { MapCords } from '../../map.interfaces';
import { MapFlow } from '../map.flow';
import { MapValues } from '../../map.values';
import MapSettings from '../../map.settings';

export class MapViewFlow extends MapFlow {
  constructor(
    mapComponent: MapComponent,
    private itemDetailsProvider: MapItemDetailsProvider,
  ) {
    super(mapComponent);
  }

  public override activate() {
    this.mapComponent.onFilterChanged(this.itemDetailsProvider.filter);
  }

  public override deactivate() {
    this.mapComponent.toggleButtonVisibility();
    this.mapComponent.mediator.reset();
  }

  public override getInitialLocation(successCallback: InitialLocationCallback) {
    navigator.geolocation.getCurrentPosition(
      (position: MapCords) => {
        successCallback(
          { lat: position.coords.latitude, lon: position.coords.longitude },
          MapSettings.DEFAULT_MAP_ZOOM,
        );
      },
      (_error) => {
        successCallback(MapValues.initialCoords, MapSettings.DEFAULT_MAP_ZOOM);
      },
    );
  }

  public override markersWereUpdated() {
    // Simply empty
  }
}
